<template>
  <div class="view">
    <el-row :gutter="20" type="flex">
      <el-col :xs="24">
        <h1 class="font--bigger m-t-0 c-black">
          <span>{{ $t('Personalize') }}</span>
        </h1>
      </el-col>
    </el-row>

    <el-row>
      <el-col :xs="24">
        <el-button type="text" @click="$router.go(-1)" class="valign-center">
          <i class="material-icons m-r-half">arrow_back</i>
          {{ $t('Back to overview') }}
        </el-button>
      </el-col>
    </el-row>

    <el-row>
      <el-col :xs="24" v-loading="isLoading">
        <el-card v-if="designId && !isLoading">
          <!-- Personalize Component -->
          <ProductPersonalize :item="design" :details="templatedetails" />
        </el-card>

        <!-- No Items -->
        <div v-if="!designId && !isLoading">
          <figure class="text-center">
            <img src="/img/illustration/hugo-list-is-empty.png" height="300" />
          </figure>
          <p class="text-center">{{ $t('There is currently no design available.') }}</p>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios';
import ProductPersonalize from '@/components/ProductPersonalize';
import * as TemplateService from '@/services/template';

export default {
  name: 'Personalize',

  components: {
    ProductPersonalize
  },

  computed: {
    design() {
      return this.$store.getters['templates/GET_DESIGN_BY_ID'](this.designId) || {};
    },

    designId() {
      if (this.$route.params.id === 'undefined') {
        return null;
      }

      return this.$route.params.id || null;
    }
  },

  data() {
    return {
      isLoading: false,
      templatedetails: {}
    };
  },

  mounted() {
    this.init();
  },

  methods: {
    init() {
      this.requestInitData();
    },

    requestDesign(id) {
      return this.$store
        .dispatch('templates/GET_DESIGN_BY_ID', { id })
        .then(response => {
          return response;
        })
        .catch(err => {
          return err;
        });
    },

    requestInitData() {
      const REQUESTS = [];

      if (this.designId && !this.design.hasOwnProperty('designId')) {
        REQUESTS.push(this.requestDesign(this.designId));
      }

      if (this.designId) {
        REQUESTS.push(this.requestTemplateDetails(this.designId));
      }

      this.isLoading = true;

      axios
        .all(REQUESTS)
        .then(
          axios.spread((...results) => {
            this.isLoading = false;
          })
        )
        .catch(err => {
          this.isLoading = false;
        });
    },

    requestTemplateDetails(id) {
      return TemplateService.getTemplateDetailsById(id)
        .then(response => {
          if (response.data) {
            this.templatedetails = response.data;
          }

          return response;
        })
        .catch(err => {
          return err;
        });
    }
  }
};
</script>

<style lang="scss" scoped></style>
